import { render, staticRenderFns } from "./ListaNivel.vue?vue&type=template&id=1c0e9a08"
import script from "./ListaNivel.vue?vue&type=script&lang=js"
export * from "./ListaNivel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports